import { render, staticRenderFns } from "./AddAdditionalField.vue?vue&type=template&id=22dfeff8&scoped=true"
import script from "./AddAdditionalField.vue?vue&type=script&lang=js"
export * from "./AddAdditionalField.vue?vue&type=script&lang=js"
import style0 from "./AddAdditionalField.vue?vue&type=style&index=0&id=22dfeff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dfeff8",
  null
  
)

export default component.exports